import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Tabs,Switch,Modal,Input, Pagination, Select,Form,message } from 'antd'

import './questionBank.less'
const { TabPane } = Tabs;
const { Option } = Select;
class QuestionBank extends Component {

  constructor(props) {
    super(props)
    this.state = {
      type: '2',
      pageSize: 10,
      pageNum: 1,
      total: 0,
      columns: [{
        title: '学科名称',
        dataIndex: 'subjectName',
        align: 'center',
        key: 'subjectName',
      },{
        title: '知识点数量',
        dataIndex: 'konwledgeNum',
        align: 'center',
        key: 'konwledgeNum',
        render: (num, obj) => {
          return (
            <Button type="link" onClick={() => {this.props.history.push('/konwledge',{subjectName: obj.subjectName,questionId: obj.subjectId})}}>{num||0}</Button>
          )
        }
      },{
        title: '笔试题数量',
        dataIndex: 'writingTestingNum',
        align: 'center',
        key: 'writingTestingNum',
      },{
        title: '面试题数量',
        dataIndex: 'interviewQuestionsNum',
        align: 'center',
        key: 'interviewQuestionsNum',
      },{
        title: '操作',
        align: 'center',
        render: (record, obj) => {
          return (
            <Button type="link" onClick={() => {this.props.history.push('/konwledge',{subjectName: obj.subjectName, questionId: obj.subjectId})}}>知识点管理</Button>
          )
        }
      }],
      interviewColumns: [
        {
          title: '岗位名称',
          dataIndex: 'name',
          align: 'center',
          key: 'name',
        },{
          title: '面经数量',
          dataIndex: 'qfIeNum',
          align: 'center',
          key: 'qfIeNum',
        },
        {
          title: 'UGC面经数量',
          dataIndex: 'ieNum',
          align: 'center',
          key: 'ieNum',
        },{
          title: '待审核UGC面经',
          dataIndex: 'ieApprovalNum',
          align: 'center',
          key: 'ieApprovalNum',
          render: (num, obj) => {
            return (
              <Button type="link" onClick={() => {this.linkDetail(obj)}}>{num||0}</Button>
            )
          }
        },{
          title: '创建人',
          dataIndex: 'createName',
          align: 'center',
          key: 'createName',
        },{
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          key: 'createTime',
        },{
          title: '发布状态',
          dataIndex: 'publish',
          key: 'publish',
          align: 'center',
          width: '90px',
          render: (text, record) => {
            return (
              <div>
                <Switch defaultChecked={text === 1 ? true : false} key={text === 1 ? true : false}  onChange={(checked) => {
                  let id = record.id
                  return (
                    Modal.confirm({
                      title: `${checked === true ? '发布学科' : '取消发布'}`,
                      okText: "确定",
                      cancelText: "取消",
                      content: (
                        <div>
                          <p>{checked === true ? '发布后此学科将同步至用户端，请谨慎操作！确定要发布吗？' : '取消发布后用户端将无法学习此学科，请谨慎操作！确定要取消发布吗？'}</p>
                        </div>
                      ),
                      onOk: () => {
                        this.isRelease(id, checked,'ok')
                      },
                      onCancel: () => {
                        this.isRelease(id, checked,'cancel')
                      }
                    })
                  )
                }} />

              </div>
            )
          }
        },{
          title: '操作',
          width: '200px',
          render: (record) => <div style={{textAlign: 'left'}}>
              <span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
                this.setState({
                  visible: true,
                  modelTitle: '编辑岗位',
                   id: record.id,
                   name: record.name,
                })
              }}>编辑</span>

              <span style={{marginRight:'15px',color: '#277FFF', cursor: 'pointer'}} onClick={()=> {
                sessionStorage.setItem('subjectId',record.id)
                this.props.history.push('/mianJing', {id: record.id, name: record.name})
              }}>面经管理</span>
              {record.publish === 0?<Button type="link" className='red-btn' onClick={() => {
                Modal.confirm({
                  title: '删除',
                  okText: "确认",
                  cancelText: "取消",
                  content: '删除后将不可恢复，请谨慎操作！确定要删除吗？',
                  onOk: () => {
                    this.delMianjing(record.id, record)
                  },
                });
              }}>删除</Button>:''}

            </div>
        }
      ],
      dataSource: [],
      mianjingList:[],
      current: 1,
      size: 10,
      isInterview: '2',
      modelTitle: '新增岗位',
      visible: false,
      channelName: '',
      name: '',
      publish: ''

    }
  }



  InitQuestion() {
    axios.get('/konwledge/question/library').then(res => {
      if (res.data.code === '200') {
        this.setState({dataSource: res.data.data})
      }
    })
  }
  // 面经模块管理
  getmMianjingList() {
    axios.post('/interviewexperience/jobpositions/list', {
      name: this.state.name,
      publish: this.state.publish,
      pageSize: this.state.size,
      pageNum: this.state.pageNum,
    }).then(res => {
      if (res.data.code === '200') {
        // console.log(res.data, '结果值')
        this.setState({mianjingList: res.data.data.list, total: res.data.data.total})
      }
    })
  }


  delMianjing(id, record) {
    if(record.ieNum>0||record.qfIeNum>0)return message.error('岗位下有面经不能删除')
    axios.get(`/interviewexperience/jobpositions/delete/${id}`).then(res => {
      if (res.data.code === '200') {
        message.success('删除成功')
        this.getmMianjingList()
      }
    })
  }
  // 发布状态
  isRelease = (id, checked, text) => {
    let url = ''
    if(checked){
      url = `/interviewexperience/jobpositions/publish/${id}`
    }else{
      url = `/interviewexperience/jobpositions/cancelPublish/${id}`
    }
    if(text === 'ok'){
      axios.get(url).then(res => {
        if (res.data.code === '200') {
          message.success('操作成功')
          // this.materialList()
          this.getmMianjingList()
        } else {
          message.error(res.data.msg)
          this.getmMianjingList()
        }
      })
    }else{
      this.getmMianjingList()
    }
  }
  linkDetail(obj) {
    localStorage.setItem('type', 'ugc');
    this.props.history.push('/mianJing',{name: obj.name,id: obj.id})
  }
  changeTabs(e) {
    console.log(e)
    this.setState({activityKey: e})
  }
  componentDidMount() {
    if(localStorage.getItem('type')) {
			this.setState({isInterview: localStorage.getItem('type') === 'face'?'1':'2'},() => {
				this.getmMianjingList()
				localStorage.removeItem('type')
			})
    }else{
      this.InitQuestion()
    }

  }
  callback=(key)=> {
		this.setState({
			isInterview: key
		}, ()=>{
      if(key === '2') {
        this.InitQuestion()
      }else {
        this.getmMianjingList()
      }

		})
	}
  searchInfo() {
    this.getmMianjingList()
  }
  pageChange = (current) => {
		console.log(current)
		this.setState({ pageNum: current }, () => {
			this.getmMianjingList()
		})

	}
	sizeChange = (current, size) => {
		console.log(current, size)
		this.setState({ pageNum: 1, size: size }, () => {
			this.getmMianjingList()
		})

	}
    // 新建岗位
  handleOk = (e) => {
		this.props.form.validateFields(async (err, values) => {
			console.log(err, values)
			let params = { ...values }
      let id = this.state.id
      params.name = values.name

			if (!err) {
        let url = this.state.modelTitle === '新建岗位' ?
          'interviewexperience/jobpositions/add' : 'interviewexperience/jobpositions/update'

        let editParams = {
          id,
          name: params.name,
        }
        const {data:res} = await axios.post(url, this.state.modelTitle === '新建岗位' ? {...params} : editParams)
        if (res.code === '200') {
          message.success(this.state.modelTitle === '新建岗位' ? '添加成功' : '编辑成功')

          this.setState({
            visible: false,
            name: '',
            modelTitle: '新增渠道',
          })
          this.getmMianjingList()
        } else {
          message.error(res.msg)
        }
			}
		})
	}
  render() {
    let {dataSource, columns,interviewColumns,isInterview, total, pageNum, modelTitle,visible, mianjingList} = this.state
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <span className="header-name">面试宝典管理</span>
				<Divider />
        <Tabs activeKey={isInterview} onChange={this.callback}>
					<TabPane tab="题库模块管理" key="2"></TabPane>
					<TabPane tab="面经模块管理" key="1"></TabPane>
				</Tabs>

          {(isInterview === '1')? <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{display: 'flex',flexWrap: 'wrap'}}>
              <div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
                <span>岗位名称：</span>
                <Input allowClear value={this.state.name} style={{ width: '160px', height: '40px', marginRight: '20px' }}
                    placeholder="岗位名称"
                    onChange={(e) => {
                      this.setState({
                          name: e.target.value
                      })
                    }}
                  ></Input>
              </div>

              <div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
                <span>发布状态：</span>
                <Select  placeholder="发布状态" value={this.state.publish} style={{ width: 120, height: '40px' }} onChange={(value)=>{
                  this.setState({
                    publish: value
                  })
                }}>
                  <Option value={''}>全部</Option>
                  <Option value={1}>已发布</Option>
                  <Option value={0}>未发布</Option>
                </Select>
              </div>
              <Button className='my-button-primary' style={{ marginLeft: '20px' }} type='primary' onClick={() => {
                this.searchInfo()
              }}>搜索</Button>
              <Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
                this.setState({
                    pageNum: 1,
                    size: 10,
                    name: '',
                    publish: ''
                },()=>{
                  this.searchInfo()
                })
              }}>重置</Button>
            </div>
            <div>
            <Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
                this.setState({ visible: true,modelTitle: '新建岗位' })
              }}>新建岗位</Button>
            </div>
          </div> : ''  }

          { (isInterview === '1') ?  <Table dataSource={mianjingList} columns={interviewColumns} rowKey={record => record.id} pagination={false} /> :
          <Table dataSource={dataSource} columns={columns} rowKey={record => record.subjectId} pagination={false} /> }
          <Pagination className="table-pagination" total={total} current={pageNum} showSizeChanger showQuickJumper pageSizeOptions={['10', '20', '50', '100']} onChange={this.pageChange} onShowSizeChange={this.sizeChange} />
        <Modal
            getContainer={true}
            title={modelTitle}
            okText="确认"
            cancelText="取消"
            visible={visible}
            onOk={() => { this.handleOk() }}
            onCancel={() => { this.setState({ visible: false,name: '' }) }}
            destroyOnClose
          >
            <Form labelCol={{ span: 6 }} wrapperCol={{ span: 12 }} onSubmit={this.handleOk} autoComplete="off">
              <Form.Item label={"岗位名称"}>
                {getFieldDecorator('name', {
                  rules: [{ required: true,  message: '请输入岗位名称!', }],
                  initialValue: modelTitle === '编辑岗位' ? this.state.name : undefined
                })(
                  <Input placeholder='请输入岗位名称' />
                )}
              </Form.Item>
            </Form>
          </Modal>

      </div>
    )
  }
}
export default  Form.create()(QuestionBank)
